import React from "react";
import PuzzlePiece from "./PuzzlePiece";
import { TAB_RATIO } from "./gameUtils";

const PUZZLE_GREEN = "#189970";

/**
 * One board slot. Empty slots show a dashed accent target; filled slots host a
 * jigsaw piece (whose full footprint is bigger than the tile, so it is offset by
 * one tab margin to align its cell to the slot). Reports its DOM node so drops
 * can be hit-tested against real geometry.
 */
const PuzzleSlot = ({
  position,
  piece,
  grid,
  tile,
  boardImage,
  composited,
  isCorrect,
  isDragging,
  disabled,
  onPiecePointerDown,
  registerRef,
}) => {
  const tab = tile * TAB_RATIO;
  const filled = piece != null;

  return (
    <div
      ref={(el) => registerRef(position, el)}
      className="relative select-none"
      style={{ width: tile, height: tile, overflow: "visible", zIndex: filled ? (isCorrect ? 2 : 4) : 1 }}
    >
      {!filled && (
        <div
          className="absolute inset-0"
          style={{
            borderRadius: 6,
            background: "rgba(24,153,112,0.06)",
            border: `1.5px dashed rgba(24,153,112,0.28)`,
          }}
        />
      )}
      {filled && (
        <div
          role="button"
          aria-label={`Puzzle piece ${piece + 1}`}
          onPointerDown={
            disabled ? undefined : (e) => onPiecePointerDown(e, piece, { kind: "slot", index: position })
          }
          className="absolute touch-none"
          style={{
            left: -tab,
            top: -tab,
            cursor: disabled ? "default" : "grab",
            opacity: isDragging ? 0 : 1,
            color: PUZZLE_GREEN,
          }}
        >
          <PuzzlePiece
            boardImage={boardImage}
            composited={composited}
            index={piece}
            grid={grid}
            tile={tile}
            lifted={false}
          />
        </div>
      )}
    </div>
  );
};

export default React.memo(PuzzleSlot);
